import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './locales';

// i18n main config
const i18nConfig = {
  resources: translations,  // resources are translation files (en.js, pt-br.js)
  fallbackLng: 'pt-BR',     // fallbackLng is default language in case of browser not detection
  defaultNS: 'translations',
  lng: navigator.language // Language detection
};

i18n
  .use(initReactI18next) // Uses React i18n package for translation
  .init(i18nConfig); // Init i18n service with main configs defined above

export default i18n;
